module.exports = __webpack_public_path__ + "img/IMG_3789.0c983ad3.jpg";